import { ReactComponent as chevronDown } from '../../../assets/icons/chevron_down.svg';
import { ReactComponent as chevronUp } from '../../../assets/icons/chevron_up.svg';
import { ReactComponent as chevronLeft } from '../../../assets/icons/chevron_left.svg';
import { ReactComponent as chevronRight } from '../../../assets/icons/chevron_right.svg';
import { ReactComponent as calendar } from '../../../assets/icons/calendario.svg';

export default {
  chevronDown,
  chevronUp,
  chevronLeft,
  chevronRight,
  calendar
};
